/*
 * @Author: Soul
 * @Date: 2021-05-31 17:23:14
 * @LastEditors: dee
 * @LastEditTime: 2022-04-26 15:25:05
 * @Description: file content
 */
export default {
  env: {
    // actId: 498
    // appId: wx22141b3e0ceea055
    // 域名: web.homtop.cn
    // 备用域名: web.ruthyxhd.com
    // 独立域名: web.ruthfckj.com
    // bizId: 848ceb3ca3024bd992bc245ab4550ec9,
    // 活动API: https://actapi2.ttrsznkj.com/hushang/doc.html
    // 核销api: https://actapi2.ttrsznkj.com/act-data/doc.html
    // 蓝湖链接: https://lanhuapp.com/url/Gyjbc-AkQx7n
    /* projectId: 6686    圣桦宝龙世家
                  6687    玄武宝龙城
                  6688    麒麟宝龙广场
                  6689    宝龙TOD未来新城
                  6690    永泰宝龙世家
                  6691    长兴宝龙世家
                  6692    兰溪宝龙广场
                  6697    凤汇壹品
                  6698    泰州宝龙世家
                  6699    高新宝龙城
                  6700    金湾宝龙城
                  10067   新生圩宝龙广场
                  10068   龙运天城宝龙世家
                  10070   海口宝龙城
                  10071   运河宝龙观邸
                  10072   宝龙雅戈尔未来城壹号
                  10073   文创甬江城
                  10074   北站宝龙城
                  10075   保利宝龙·和光悦湖
                  10092   宝龙地产新春霸屏活动
                  10294   景德镇宝龙世家
                  10295   云樾珑湾
                  10296   常熟宝龙广场
                  10297   东腾璟庭
                  10298   宝龙TOD奉甬新城
                  10300   常州宝龙广场
                  10301   宝龙理想启城
                  10319   宝龙422全推 */
    prod: {
      site: {
        appid: "wx22141b3e0ceea055",
        protocol: "http:",
        domain: "web.homtop.cn",
      },
      routersActWxauth: {
        fake: {
          test: {
            // actOpenId: 'oy6lit6KVk-e7b2pydgV0LykEiLY',
            // actOpenId: 'otuZstywJRGF3gokIG3O1Jyn8bpw',
            actOpenId: 'otuZst3OniRWJDceHQtlvgjjjeDE',
            actAppId: 'wx22141b3e0ceea055',
          }
        }
      },
      servicesActWxjssdk: {
        appid: 'wxa3688bcc3a5fd4e2',
      },
      apiActWxauth: {
        appid: "wx22141b3e0ceea055",
        protocol: "http:",
        domain: "web.homtop.cn"
      },
      apiActLogicPlatform: {
        protocol: "http:",
        domain: "web.homtop.cn",
      },
      apiActLogicDengfan: {
        protocol: "https:",
        domain: "actapi2.ttrsznkj.com",
      },
      httpActLogicDengfan: {
        appId: "wx22141b3e0ceea055",
        actId: 498,
        token: 'df5fe49858504c25bb7518410aaf70a2' //核销奖品所需要的token
      },
      apiRushiH5Platform: {
        protocol: "http:",
        domain: "ygcgz.ttrushi.com",
      },
      httpRushiH5Platform: null,
      servicesRushiH5jssdk: {
        pageid: 306535,
        psn: "bcf988435a4048f1a6e4e386b69b6442",
        projectid: 8057,
        saleslead: {
          browse: true,
          share: true,
          leavePhone: true
        }
      },
      apiRushiWxPlatform: {
        protocol: "http:",
        domain: "ygcgz.ttrushi.com",
      },
      httpRushiWxPlatform: {
        borrowOpenid: 'og2HS5gm-SAafiJhFuXY-4m_VUuY',
        borrowPassport: '781930234641d3e39fd22629eff1653d'
      }
    },
  },
  APPID: 'wx22141b3e0ceea055',
  actId: 498,
  bizId: '848ceb3ca3024bd992bc245ab4550ec9',
  projectId: 10319,
  audioSrc: 'http://assets.rurushishi.com/activies/rchd-blind-box-2021-11/bgm.mp3', //背景音乐 格式mp3 大小1M以内
  apiName: 'hushang', // 接口名字
  imgHost: 'http://assets.rurushishi.com/activies/blyky-fruit-ninja-2022-04/', // 静态素材oss地址
  gameUrl: 'http://web.homtop.cn/act/online/blyky-fruit-ninja-2022-04/web-mobile/index.html',
  company: '开发商', // 免责声明公司名
  prizeTime: '2022年5月1日-5月10日', // 领奖时间
  shareTitle: '宝龙地产邀您同心战疫！戴森，华为，2022防疫津贴及多重防疫礼包等你来抽！', // 分享标题
  shareContent: '多盘联动，共同守护健康家园。', // 分享内容
  pageTitle: '宝龙全民云抗疫', // 页面头部标题
  OSSVersion: 3, // 静态资源版本号防止图片缓存，替换同名图片后修改此处
  openDebug: false, // 开启vclonse调试模式
  openYqAnalytics: true, // 开启原圈数据统计监控
  openSalesLeads: false,  // 开启销售线索
};